import { ArtworkHelper } from "../../../singleton/ArtworkHelper";
import { createShortID, updateARUrl } from "../../../utils/artwork-qr-utils";
import { proxiedUrlForArtwork } from "../../../utils/media-url-utils";

export function useArtworks() {
  const getPublicDomainArtwork = async asset => {
    //1. is a NGA artwork
    let artwork;
    let qrCodeId;
    if (asset?.artwork?.museum == "nga" || asset?.artwork?.museum == "met") {
      qrCodeId = await createShortID(asset?.url);
    }

    if (asset?.artwork?.museum == "nga") {
      let truncatedDimensions = asset?.artwork?.dimensions
        ? asset?.artwork?.dimensions.replaceAll("×", "x")
        : asset?.artwork?.dimensions;
      artwork = await ArtworkHelper.getInstance().generateArtworkData({
        artistName: asset?.artwork?.author || asset?.artwork?.artist,
        artName: asset?.artwork?.title,
        dimensions: truncatedDimensions,
        unit: asset?.artwork?.unit,
        description: "National Gallery of Art, Washington",
        imageUrl: asset?.url,
        fileUrl: asset?.url,
        qrCodeId,
        mediaType: "image",
        isPublicDomainArt: true
      });
    } else if (asset?.artwork?.museum == "met") {
      artwork = await ArtworkHelper.getInstance().generateArtworkData({
        artistName: asset?.artwork?.author || asset?.artwork?.artist,
        artName: asset?.artwork?.title,
        dimensions: asset?.artwork?.dimensions,
        medium: "Custom",
        customMedium: asset?.artwork?.medium,
        description: "The Metropolitan Museum of Art",
        imageUrl: proxiedUrlForArtwork(asset?.url),
        fileUrl: proxiedUrlForArtwork(asset?.url),
        qrCodeId,
        mediaType: "image",
        isPublicDomainArt: true
      });
    }

    if ((artwork && artwork?.artwork_model && asset?.artwork?.museum == "nga") || asset?.artwork?.museum == "met") {
      await updateARUrl(artwork?.artwork_model, qrCodeId);
    }

    return artwork;
  };

  return {
    getPublicDomainArtwork
  };
}

// async generateArtworkData({
//   artistName, artworkDate, dimensionsX, dimensionsY, dimensionsZ, unit, medium,
//   artistStatement, artName, description, fileUrl, imageUrl, mediums, glbModel, mediaType = "image",
//   ...rest
// }) {
